module.exports = __webpack_public_path__ + "static/media/nurse-gif.9ed8d116.gif";